import { ContentItem } from "@at/design-system-patterns";

import { LeasingTechnicalSpecificationQuery_search_Search_advert_Advert } from "../../query/__generated__/leasing-technical-specification.query";
import { getContentItemRowData } from "../get-content-item-row-data/get-content-item-row-data";

export const getTechSpecData = (
  data:
    | LeasingTechnicalSpecificationQuery_search_Search_advert_Advert
    | undefined,
): ContentItem[] => {
  const advertData = data?.specification;
  const batteryRange = advertData?.battery?.range;
  const charging = advertData?.battery?.charging;
  const techData = advertData?.techData;
  const batteryContent = getContentItemRowData({
    rowHeading: "Battery",
    object: {
      Range:
        batteryRange?.range && batteryRange?.unit
          ? `${batteryRange.range} ${batteryRange.unit}`
          : null,
      "Charge time": charging?.chargeTime,
      "Quick charge time": charging?.quickChargeTime,
    },
  });
  const dimensionsContent = getContentItemRowData({
    rowHeading: "Dimensions",
    object: {
      "Vehicle height": techData?.vehicleHeight,
      "Vehicle length": techData?.vehicleLength,
      "Vehicle width": techData?.vehicleWidth,
      "Boot space with seats up": techData?.bootspaceSeatsUp,
      "Minimum kerb weight": techData?.minimumKerbWeight,
    },
  });
  const engineAndDrivetrainContent = getContentItemRowData({
    rowHeading: "Engine and drivetrain",
    object: {
      "Fuel type": advertData?.fuel,
      Transmission: techData?.transmission,
      Wheelbase: techData?.wheelbase,
    },
  });
  const generalContent = getContentItemRowData({
    rowHeading: "General",
    object: {
      "Number of doors": advertData?.doors,
      "Number of seats": techData?.numberOfSeats,
      "Warranty miles": techData?.warrantyMiles,
      "Warranty years": techData?.warrantyYears,
      "Insurance group": techData?.insuranceGroup,
    },
  });
  const performanceContent = getContentItemRowData({
    rowHeading: "Performance",
    object: {
      "Zero to sixty mph": techData?.zeroToSixtyMph,
      "Top speed": techData?.topSpeed,
      "Engine power": techData?.enginePower,
      "Engine torque": techData?.engineTorque,
    },
  });

  const techSpecDataUnfiltered: (ContentItem | null)[] = [
    batteryContent,
    dimensionsContent,
    engineAndDrivetrainContent,
    generalContent,
    performanceContent,
  ];

  const techSpecData: ContentItem[] = techSpecDataUnfiltered.filter(
    (data): data is ContentItem => data != null,
  );

  return techSpecData;
};
